import React, { useState, useEffect } from 'react';
import { Card, Input, Select, Button, Space, Row, Col, Divider, Tag } from 'antd';
import { SearchOutlined, FilterOutlined, ClearOutlined } from '@ant-design/icons';

const { Option } = Select;

const UserTableFilter = ({ onApplyFilters }) => {
  // Filter states
  const [nameSearch, setNameSearch] = useState('');
  const [emailSearch, setEmailSearch] = useState('');
  const [roleFilter, setRoleFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  // Update active filters count whenever any filter changes
  useEffect(() => {
    let count = 0;
    if (nameSearch) count++;
    if (emailSearch) count++;
    if (roleFilter.length > 0) count++;
    if (statusFilter.length > 0) count++;
    setActiveFiltersCount(count);
  }, [nameSearch, emailSearch, roleFilter, statusFilter]);

  // Apply filters
  const handleApplyFilters = () => {
    const filters = {
      nameSearch: nameSearch.trim(),
      emailSearch: emailSearch.trim(),
      roleFilter,
      statusFilter
    };
    onApplyFilters(filters);
  };

  // Clear all filters
  const handleClearFilters = () => {
    setNameSearch('');
    setEmailSearch('');
    setRoleFilter([]);
    setStatusFilter([]);
    onApplyFilters({
      nameSearch: '',
      emailSearch: '',
      roleFilter: [],
      statusFilter: []
    });
  };

  // Role options
  const roleOptions = [
    { value: 'ADMIN', label: 'Admin', color: '#108ee9' },
    { value: 'EDITOR', label: 'Editor', color: '#87d068' },
    { value: 'READER', label: 'Reader', color: '#2db7f5' }
  ];

  // Status options
  const statusOptions = [
    { value: 'ACTIVE', label: 'Active', color: '#52c41a' },
    { value: 'INACTIVE', label: 'Inactive', color: '#ff4d4f' }
  ];

  return (
    <Card 
      className="user-filter-card"
      title={
        <Space>
          <FilterOutlined /> 
          <span>Filter Users</span>
          {activeFiltersCount > 0 && (
            <Tag color="blue">{activeFiltersCount} active</Tag>
          )}
        </Space>
      }
      extra={
        <Button 
          icon={<ClearOutlined />} 
          onClick={handleClearFilters}
          disabled={activeFiltersCount === 0}
        >
          Clear All
        </Button>
      }
      style={{ marginBottom: 16, borderRadius: 8 }}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} md={6}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Name Search</div>
            <Input
              placeholder="Search by name"
              prefix={<SearchOutlined />}
              value={nameSearch}
              onChange={(e) => setNameSearch(e.target.value)}
              allowClear
            />
          </div>
        </Col>
        
        <Col xs={24} md={6}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Email Search</div>
            <Input
              placeholder="Search by email"
              prefix={<SearchOutlined />}
              value={emailSearch}
              onChange={(e) => setEmailSearch(e.target.value)}
              allowClear
            />
          </div>
        </Col>
        
        <Col xs={24} md={6}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Role</div>
            <Select
              mode="multiple"
              placeholder="Filter by role"
              value={roleFilter}
              onChange={setRoleFilter}
              style={{ width: '100%' }}
              optionLabelProp="label"
            >
              {roleOptions.map(role => (
                <Option key={role.value} value={role.value} label={role.label}>
                  <Tag color={role.color} style={{ marginRight: 8 }}>
                    {role.label}
                  </Tag>
                </Option>
              ))}
            </Select>
          </div>
        </Col>
        
        <Col xs={24} md={6}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Status</div>
            <Select
              mode="multiple"
              placeholder="Filter by status"
              value={statusFilter}
              onChange={setStatusFilter}
              style={{ width: '100%' }}
              optionLabelProp="label"
            >
              {statusOptions.map(status => (
                <Option key={status.value} value={status.value} label={status.label}>
                  <Tag color={status.color} style={{ marginRight: 8 }}>
                    {status.label}
                  </Tag>
                </Option>
              ))}
            </Select>
          </div>
        </Col>
      </Row>
      
      <Divider style={{ margin: '16px 0' }} />
      
      <Row justify="end">
        <Button 
          type="primary" 
          icon={<FilterOutlined />} 
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
      </Row>
    </Card>
  );
};

export default UserTableFilter;